/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import cn from 'classnames';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { PageHeader } from '../../../../app/components/PageHeader';
import CardComponent from '../../../containers/App/Components/Card/Card';
import LoadingCard from '../../../containers/App/Components/LoadingCard/LoadingCard';
import PaginationComponent from '../../../containers/App/Components/Pagination/Pagination';
import { ChevronRight, Home, Sort } from '../../../components/Icon';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import LoadingFilters from '../../../containers/App/Components/LoadingFilters/LoadingFilters';

import {
  applyTransporterFilters,
  changeTransporterFilter,
  deleteTransporter,
  fetchTransporters,
  setTransportersSort,
} from '../actions';
import { setScrollPosition } from '../../Actions/actions';
import { toggleNotification } from '../../Companies/actions';

import {
  selectTransporterCount,
  selectTransporterFilter,
  selectTransporterPaginator,
  selectTransporters,
} from '../selectors';
import { selectWorks } from '../../Api/selectors';
import { REQUEST_TRANSPORTERS, SET_TRANSPORTER_SORT } from '../constants';
import s from './overview.module.css';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { TransporterCreateModal } from '../components/createTransporter';
import { HBox } from '../../../components/Box';

dayjs.extend(customParseFormat);

const STATE = {
  sort: null,
  sort_direction: 'down',
  isShowAddModal: false,
  isShowMore: true,
  currentPage: 0,
  localPaginator: {
    limit: 50,
    offset: 0,
    itemsCount: 0,
  },
  filteredVehicles: [],
};

/* eslint-disable react/prefer-stateless-function */
class TransportersOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  componentDidMount() {
    this.props.fetch();
  }

  componentDidUpdate(prevProps, prevState) {}

  get locationState() {
    return this.props.location?.state?.state;
  }

  get noSortingTypes() {
    return this.cols();
  }

  getTypesTosort(type) {
    let types = {
      info: 'model_name',
    };

    return types[type] || type;
  }

  sortOn(field) {
    let direction = 'none';
    let sortType;

    switch (field) {
      case 'info': {
        sortType = 'model_name';
        break;
      }

      default:
        sortType = field;
    }

    let order;
    if (this.props.filter?.sortType == sortType) {
      if (!this.props.filter?.order) order = 'asc';
      if (this.props.filter?.order == 'asc') order = 'desc';
    } else {
      order = 'asc';
    }
    this.setState({ direction: !order ? 'none' : order == 'asc' ? 'up' : 'down' });
    order ? this.props.setSort(sortType, order) : this.props.setSort('', '');
  }

  selectPage = newPage => {
    const newOffset = newPage * this.props.paginator?.limit ?? 0;
    this.props.setScrollPosition(null);

    this.setState(
      prev => ({
        currentPage: newPage,
      }),
      this.props.changeFilter('offset', newOffset),
    );
  };

  cols() {
    return ['id', 'name', 'surname', 'phoneNumber', 'email', 'remarks', 'edit'];
  }

  toggleDiv = () => {
    this.setState(prevState => ({
      isShowMore: !prevState.isShowMore,
    }));
  };

  render() {
    if (this.props.work)
      return (
        <>
          <PageHeader
            title={
              <>
                <Home />
                {this.lbl('transport_order.overview.title')}
                {this.props.count !== null ? <span className="label number">{this.props.count}</span> : null}
              </>
            }
            breadCrumbs={
              <>
                <a href="/">Vindat</a>
                <ChevronRight />
                {this.lbl('transporter.overview.title')}
              </>
            }
          />
          <LoadingFilters />
        </>
      );

    const transporters = this.props.transporters;
    const { localPaginator } = this.state;
    const {
      currentPage,
      localPaginator: { limit },
    } = this.state;

    return (
      <div className="container-fluid p-0">
        <PageHeader
          title={
            <>
              <Home />
              {this.lbl('transporter.overview.title')}
              {this.props.count !== null ? <span className="label number">{this.props.count}</span> : null}
            </>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('transporter.overview.title')}
            </>
          }
        ></PageHeader>

        <div className="container-fluid p-0">
          <HBox right className="mb-3">
            <TransporterCreateModal />
          </HBox>
          {/* <TransportOrderSearch /> */}
        </div>

        {window.innerWidth >= 1024 && this.props.count !== (null || 0) ? (
          <table className={cn('table', 'table-hover', 'mb-0', s.wrapper)}>
            <thead className="align-middle">
              <tr className={cn('align-middle', s.thead)}>
                <th className={s.headTh}>
                  <CheckboxComponent
                    disabled={this.props.weblogin}
                    checked={this.state.allSelected == '1'}
                    onChange={e => {
                      if (this.state.allSelected == '1') {
                        this.setState({ allSelected: '0' });
                        return this.onRemoveAll(e, this.vehicles);
                      }
                      this.setState({ allSelected: '1' });
                      return this.onSelectAll(e, this.vehicles);
                    }}
                  />
                </th>
                {this.cols().map((col, index) => (
                  <th className={s.headTh} key={`${col}-${index}`} onClick={() => this.sortOn(col)}>
                    <div className={cn('d-flex gap-2 text-muted', s.spanContainer)}>
                      {this.renderHeaderCell(col)}

                      {!this.noSortingTypes?.includes(col) && (
                        <Sort
                          direction={this.getTypesTosort(this.props.filter?.sortType) == col ? this.state.direction : 'none'}
                        />
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>{transporters.filter(t => t).map(transporter => this.renderRow(transporter))}</tbody>
          </table>
        ) : (
          <>
            {transporter
              .filter(t => t)
              .map(transporter => (
                <div className="rows">{this.renderCard(transporter)}</div>
              ))}
          </>
        )}

        {!!this.props.transporters?.length && this.props.paginator?.itemsCount > this.props.paginator?.limit && (
          <div className="d-flex justify-content-center mt-2 mb-5 mb-md-0">
            <PaginationComponent paginator={this.props.paginator} selectPage={this.selectPage} />
          </div>
        )}
      </div>
    );
  }

  renderCard = transporter => {
    const establishmentName = "In de Wal Auto's B.V.";

    if (this.props.work) return <LoadingCard />;

    return (
      <CardComponent
        key={vehicle.vehicleId}
        id={`item${vehicle.vehicleId}`}
        onClick={() => {}}
        transporterPage
        title={
          <div className={s.cardTitle}>
            <div className={s.containerInfo}>
              <span className={s.cardInfoCar}>
                <strong>
                  {transporter?.name}&nbsp;
                  {transporter?.surname}
                </strong>
              </span>
              <span>{transporter?.phoneNumber}</span>
              <span>{transporter?.email}</span>
            </div>
          </div>
        }
        label={<div className={s.statusCard}></div>}
      >
        {/* <div className={cn('text-muted', s.gridCard)}>
          <div className={s.gridCardColumn}>
            <h6 className={s.gridCardItem}>{<RegplateLabel regplate={vehicle.regplate} width="80" />}</h6>
            <h6 className={s.gridCardItem}>{date?.split?.('-').pop() ?? '-'}</h6>
            <h6 className={s.gridCardItem}>{parseInt(vehicle.mileage || '0').toLocaleString() + ' km'}</h6>
            <h6 className={s.gridCardItem}>
              {vehicle?.transmission_type?.charAt(0).toUpperCase() + vehicle?.transmission_type?.slice(1) ?? '-'}
            </h6>
          </div>

          <div className={s.gridCardColumn}>
            <h6 className={s.gridCardItem}>{vehicle?.vin ?? '-'}</h6>
            <h6 className={s.gridCardItem}>
              {vehicle?.tax_type?.charAt(0).toUpperCase() + vehicle?.tax_type?.slice(1) ?? '-'}
            </h6>
            <h6 className={s.gridCardItem}>
              {vehicle?.fuel_type?.charAt(0).toUpperCase() + vehicle?.fuel_type?.slice(1) ?? '-'}
            </h6>
            <h6 className={s.gridCardItem}>{vehicle?.id ?? '-'}</h6>
          </div>
        </div>
        <div className={s.buttonCard}>
          <div className={s.button}></div>
        </div> */}
      </CardComponent>
    );
  };

  handleClick(event, itemId) {
    this.to(`/transporters/${itemId}`, event?.ctrlKey || event?.metaKey);
  }

  renderText(text) {
    return <strong>{text}</strong>;
  }

  handleTableRowClick = (event, vehicleId) => {
    const excludeElements = ['input', 'img'];
    const targetElement = event.target.tagName.toLowerCase();
    if (!excludeElements.includes(targetElement)) {
      // this.handleClick(event, vehicleId);
    }
  };

  renderRow(transporter) {
    return (
      <tr
        className={`align-middle ${s.thead}`}
        key={transporter.id}
        id={`item${transporter.id}`}
        onClick={event => this.handleTableRowClick(event, transporter.id)}
      >
        <td className={s.bodyTd}>
          <div className={s.checkboxContainerTd}>
            <CheckboxComponent disabled={this.props.weblogin} />
          </div>
        </td>

        {this.cols().map(col => (
          <td className={s.bodyTd}>{this.renderCell(col, transporter)}</td>
        ))}
      </tr>
    );
  }

  renderHeaderCell(col) {
    switch (col) {
      case 'isHome':
        return '';
      default:
        return this.lbl(`transporter.overview.column.${col}`);
    }
  }

  renderCell(col, transporter) {
    const establishmentName = "In de Wal Auto's B.V.";

    const key = `${col}-${transporter.id}`;

    const fn = () => {
      switch (col) {
        case 'name':
          return (
            <div key={key} className={s.gridContainer}>
              <div className={s.carInformation}>
                <div className={s.brandName}>{transporter?.name}</div>
              </div>
            </div>
          );

        case 'surname':
          return (
            <div key={key} className={s.gridContainer}>
              <div className={s.carInformation}>
                <div className={s.brandName}>{transporter?.surname}</div>
              </div>
            </div>
          );
          break;

        case 'phoneNumber':
          return <>{transporter?.phoneNumber}</>;
        case 'email':
          return <>{transporter?.email}</>;
        case 'edit':
          // return <ButtonComponent style={'ButtonSoftEdit'}>{this.lbl('edit')}</ButtonComponent>;
          return <TransporterCreateModal transporterId={transporter?.id} />;
        case 'delete':
          return (
            <ButtonComponent style={'ButtonSoftDelete'} onClick={() => this.props.delete(transporter?.id)}>
              {this.lbl('delete')}
            </ButtonComponent>
          );

        default:
          return transporter[col];
      }
    };
    return (
      <div className={`col-${col}`} key={`${col}-${transporter.id}`}>
        {fn()}
      </div>
    );
  }
}

TransportersOverviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    transporters: selectTransporters(),
    filter: selectTransporterFilter(),
    count: selectTransporterCount(),
    paginator: selectTransporterPaginator(),

    work: selectWorks([REQUEST_TRANSPORTERS]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(fetchTransporters());
    },
    delete(transporterId, callback) {
      dispatch(deleteTransporter(transporterId, callback));
    },
    changeFilter: (name, value) => {
      dispatch(changeTransporterFilter(name, value));
    },

    setScrollPosition(pos) {
      dispatch(setScrollPosition(pos));
    },
    toggleNotification() {
      dispatch(toggleNotification('0'));
    },
    async setSort(type, order) {
      try {
        const result = await dispatch(setTransportersSort(type, order));
        if (result?.type == SET_TRANSPORTER_SORT) {
          dispatch(applyTransporterFilters());
        }
      } catch (e) {}
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportersOverview = compose(withConnect, withRouter)(TransportersOverviewComp);
